import { FEATURES, PRODUCT_FAMILY, PRODUCTS } from '@/base/constants/authorization'

export const searchAdsIntelAccessRule = {
  $and: [
    { product: { $eq: PRODUCT_FAMILY.SA_INTEL } },
    { name: { $eq: PRODUCTS.SA_INTEL_ENTERPRISE } },
    {
      featureSet: {
        $elemMatch: {
          type: { $eq: FEATURES.ACCESS_SEARCHADS_INTELLIGENCE },
        },
      },
    },
  ],
}
export const searchByAppAccessRule = searchAdsIntelAccessRule
export const searchByKeywordAccessRule = searchByAppAccessRule
export const searchByCompetitorAccessRule = searchByAppAccessRule
export const topAdvertisersAccessRule = searchByAppAccessRule
export const todayTabAccessRule = searchByAppAccessRule
export const searchTabAccessRule = searchByAppAccessRule
export const productPagesAccessRule = searchByAppAccessRule
export const cppMetricsAccessRule = searchByAppAccessRule

export const cppIntelligenceAccessRule = {
  $and: [
    { product: { $eq: PRODUCT_FAMILY.CPP } },
    { name: { $eq: PRODUCTS.CPP_INTEL_ENTERPRISE } },
    {
      featureSet: {
        $elemMatch: {
          type: { $eq: FEATURES.ACCESS_CPP_INTELLIGENCE },
        },
      },
    },
  ],
}
